import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {
  ILikeV4,
  IMyPagePurchaseEpisode,
  IMyPageTabV4,
  IPurchaseV4,
  IRecentV4,
} from '../type';

export interface IStateMyPage {
  tab: IMyPageTabV4;
  editTab: IMyPageTabV4;
  // 다음 페이지 로드 시 offset 계산을 위한 비교 용도
  // 참고: https://podotree.atlassian.net/browse/KWQA-17849
  originEditOwn?: IPurchaseV4;
  // TODO: V4 아래 타입들 제거하자
  episode: IMyPagePurchaseEpisode;
}

export const DEFAULT_EPISODE_STATE: IMyPagePurchaseEpisode = {
  remainTicketCount: 0,
  episodes: [],
  contentTitle: '',
};

const INITIAL_STATE: IStateMyPage = {
  tab: {},
  editTab: {},
  episode: DEFAULT_EPISODE_STATE,
};

export default createReducer<IStateMyPage, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.AddMyPageEpisodes]: (state, action) => {
      const {isFirst, data} = action.payload;
      isFirst && (state.episode.episodes = []);
      state.episode.contentTitle = data.contentTitle;
      state.episode.remainTicketCount = data.remainTicketCount;
      state.episode.episodes.push(...data.episodes);
    },
    [ActionType.SetLikeAlarm]: (state, action) => {
      const {contentId, isAlarmOn} = action.payload;
      const findItem = state.tab.like?.contents.find(
        item => item.content.id === contentId
      );
      findItem && (findItem.isLike = isAlarmOn);
    },
    [ActionType.AddTabItems]: (state, action) => {
      const {tab, isEdit, isFirst, ...restPayload} = action.payload;
      const tabState = isEdit ? state.editTab : state.tab;
      const restTabPayload: IMyPageTabV4 = restPayload;

      const recent = getTabPayload(tabState.recent, restTabPayload.recent);
      const like = getTabPayload(tabState.like, restTabPayload.like);
      const own = getTabPayload(tabState.own, restTabPayload.own);

      tabState.recent = isFirst ? restTabPayload.recent : recent;
      tabState.like = isFirst ? restTabPayload.like : like;
      tabState.own = isFirst ? restTabPayload.own : own;
      if (tab === 'own' && isEdit) {
        /**
         * 구매탭 > 편집 모드에서 다음 페이지 정보를 가져오기 전에
         * 사용자가 hidden 처리한 데이터(tabState.own)와 비교하기 위한 값
         *
         * 다음 페이지 API를 받아오면 사용자가 hidden한 개수를 다시 비교해야 하기에
         * getTabPayload(tabState.own, restTabPayload.own) 값을 그대로 originEditOwn에 넣어줌
         *
         * ex)
         * - offset: 10
         * - 1페이지 10개 작품(hiddenCount: 0개), 사용자가 3개 작품 hidden 처리
         *   -> 2번 페이지 offset: 7 (10-3)
         * - 2페이지 10개 작품 추가, 총 20개 작품(hiddenCount: 3), 사용자가 4개 작품 hidden + 2개 작품 active
         *   -> 3번 페이지 offset: 16 (7 + 10 - 4 + 2 + 1)
         */
        state.originEditOwn = isFirst ? restTabPayload.own : own;
      }
    },
    [ActionType.TogglePurchasedContent]: (state, action) => {
      const {toggleId, isHidden} = action.payload;
      const selectedContent = state.editTab.own?.contents.find(
        item => item.id === toggleId
      );
      if (selectedContent) {
        selectedContent.isHidden = isHidden;
      }
    },
  }
);

function getTabPayload<T extends IRecentV4 | ILikeV4 | IPurchaseV4>(
  tabState?: T,
  tabPayload?: T
): T | undefined {
  return tabState && tabPayload
    ? {...tabState, contents: [...tabState.contents, ...tabPayload.contents]}
    : undefined;
}
